import { render, staticRenderFns } from "./SliceLegalSection.vue?vue&type=template&id=3606e054&lang=pug&"
import script from "./SliceLegalSection.vue?vue&type=script&lang=js&"
export * from "./SliceLegalSection.vue?vue&type=script&lang=js&"
import style0 from "./SliceLegalSection.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports